import styled from '@emotion/styled';
import { Shape, Button } from '@teko/ds-desktop';
import { RightOutlined } from '@teko/ds-icon';
import React, { useRef, useState, useEffect } from 'react';
import { t } from '../../i18n.es.js';

const Description = React.forwardRef(({
  content,
  maxHeight,
  showLessLabel,
  showMoreLabel,
  className,
  renderShowMore
}, ref) => {
  var _a;
  const contentWrapper = useRef(null);
  const htmlRef = useRef(null);
  const [expanded, setExpanded] = useState();
  const expandContent = (showMore) => {
    var _a2, _b;
    const contentElement = htmlRef.current;
    setExpanded(showMore);
    if (showMore) {
      (_a2 = contentWrapper.current) == null ? void 0 : _a2.style.setProperty("max-height", (contentElement == null ? void 0 : contentElement.offsetHeight) + "px");
    } else {
      (_b = contentWrapper.current) == null ? void 0 : _b.style.setProperty("max-height", maxHeight + "px");
    }
  };
  useEffect(() => {
    const contentElement = htmlRef.current;
    if (contentElement) {
      const { offsetHeight } = contentElement;
      if (offsetHeight > maxHeight) {
        expandContent(false);
      }
    }
  }, [htmlRef]);
  return /* @__PURE__ */ React.createElement("div", {
    ref,
    className
  }, /* @__PURE__ */ React.createElement(Shape, {
    padding: "s16"
  }, /* @__PURE__ */ React.createElement(ContentWrapper, {
    ref: contentWrapper,
    maxHeight
  }, /* @__PURE__ */ React.createElement(HtmlRenderer, {
    ref: htmlRef,
    dangerouslySetInnerHTML: { __html: content }
  }))), expanded !== void 0 && (renderShowMore ? renderShowMore({
    expanded,
    toggle: () => expandContent(!expanded),
    label: (_a = expanded ? showLessLabel : showMoreLabel) != null ? _a : ""
  }) : /* @__PURE__ */ React.createElement(ShowMoreButton, {
    block: true,
    size: "s",
    suffix: /* @__PURE__ */ React.createElement(RightOutlined, {
      className: "suffix",
      "aria-expanded": expanded
    }),
    onClick: () => expandContent(!expanded)
  }, expanded ? showLessLabel : showMoreLabel)));
});
const ContentWrapper = styled.div`
  overflow: hidden;
  max-height: ${(props) => props.maxHeight}px;
  transition: max-height 0.5s ease-in-out;
`;
const HtmlRenderer = styled.div`
  max-width: 100%;
  img {
    max-width: 100%;
  }
`;
const ShowMoreButton = styled(Button)`
  border: none;
  border-top: 1px solid ${(props) => props.theme.colors.divider};
  border-radius: 0;
  color: ${(props) => props.theme.colors.link500};
  padding: 0.625rem;
  height: unset;

  .button-text {
    font-weight: 400;
  }
  :hover {
    border-top: 1px solid ${(props) => props.theme.colors.divider};
    color: ${(props) => props.theme.colors.link600};
  }
  .suffix {
    /* transition: transform 0.5s ease-in-out; */
    &[aria-expanded='true'] {
      transform: rotate(-90deg);
    }
  }
`;
Description.displayName = "Description";
Description.defaultProps = {
  showMoreLabel: t("Xem th\xEAm"),
  showLessLabel: t("Thu g\u1ECDn"),
  maxHeight: 500
};

export { Description };
